module.exports["gulpConcat"] = function() { return require("@swissquote/gulp-concat"); };
module.exports["gulpEslintNew"] = function() { return require("gulp-eslint-new"); };
module.exports["gulpNewer"] = function() { return require("@swissquote/gulp-newer"); };
module.exports["pluginError"] = function() { return require("plugin-error"); };